// @flow strict

import * as React from 'react';
import WistiaChannel from './WistiaChannel';

type Props = {|
  channelId: string,
|};

export default (props: Props) => {
  const { channelId } = props;
  return <WistiaChannel channelId={channelId} />;
};
